import {EventEmitter, Injectable, OnDestroy} from '@angular/core';
import {BreadCrumb} from "./bread-crumb";
import {LogRoutingService} from "../log/log-routing.service";
import {RoutesRecognized} from "@angular/router";
import {SessionStorageStackService} from "./session-storage-stack.service";

@Injectable({
  providedIn: 'root'
})
export class BreadCrumbLocalStorageService implements OnDestroy {

  private stack: SessionStorageStackService;

  routeChanged: EventEmitter<BreadCrumb[]> = new EventEmitter<BreadCrumb[]>();

  constructor() {
    this.stack = new SessionStorageStackService('breadCrumb' + new Date().getUTCMilliseconds());
  }

  ngOnInit(): void {

  }

  public getBreadcrumbs(e: RoutesRecognized): BreadCrumb[] {
    this.stack.clearAllElements();
    this.pushMainPageBreadcrumb();
    let target = LogRoutingService.resolveActionSource(e.url, false);

    let currBreadCamp = {
      url: e.url,
      label: target,
      step: 1
    };
    this.stack.pushNew(currBreadCamp);

    let result = this.stack.getBreadCrumbs();
    this.routeChanged.emit(result);
    return result;
  }

  public getBreadcrumbsArray(): BreadCrumb[] {
    return this.stack.getBreadCrumbs();
  }

  public static isInfoPage(url: string): boolean {
    return LogRoutingService.isInfoPage(url);
  }

  ngOnDestroy(): void {
    this.stack.clearLocalStorage();
  }

  private pushMainPageBreadcrumb() {
    let mainPageBreadcrumb = {
      url: '/',
      label: 'url',
      step: 0
    };
    this.stack.pushNew(mainPageBreadcrumb);
  }
}
